import React from 'react';
import { BudgetSummaryData } from '../types/budget';
interface BudgetSummaryProps {
  data: BudgetSummaryData;
}
export function BudgetSummary({
  data
}: BudgetSummaryProps) {
  const formatCurrency = (value: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value);
  const shortfall = data.totalBudget - data.constructionEscrow;
  return <div className="mb-6 space-y-4" data-id="element-28">
      {/* Top Stats Row */}
      <div className="grid grid-cols-3 gap-3" data-id="element-29">
        <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm" data-id="element-30">
          <p className="text-[10px] font-body font-thin text-gray-400 uppercase tracking-wider mb-1" data-id="element-31">
            Square Footage
          </p>
          <p className="text-lg font-heading font-light text-primary tabular-nums" data-id="element-32">
            {new Intl.NumberFormat('en-US').format(data.squareFootage)}
          </p>
        </div>
        <div className="bg-tertiary/10 border border-tertiary/20 rounded-lg p-4 shadow-sm" data-id="element-33">
          <p className="text-[10px] font-body font-thin text-gray-500 uppercase tracking-wider mb-1" data-id="element-34">
            % Complete After Rough
          </p>
          <p className="text-lg font-heading font-light text-primary tabular-nums" data-id="element-35">
            {data.percentCompleteAfterRough}%
          </p>
        </div>
        <div className="bg-tertiary/10 border border-tertiary/20 rounded-lg p-4 shadow-sm" data-id="element-36">
          <p className="text-[10px] font-body font-thin text-gray-500 uppercase tracking-wider mb-1" data-id="element-37">
            Soft Cost %
          </p>
          <p className="text-lg font-heading font-light text-primary tabular-nums" data-id="element-38">
            {data.softCostPercent.toFixed(2)}%
          </p>
        </div>
      </div>

      {/* Budget & Escrow Row */}
      <div className="grid grid-cols-2 gap-3" data-id="element-39">
        {/* Left: Budget Info */}
        <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm space-y-3" data-id="element-40">
          <div className="flex justify-between items-center" data-id="element-41">
            <span className="text-xs font-body font-thin text-gray-500" data-id="element-42">
              Construction Budget
            </span>
            <span className="text-sm font-body font-medium text-primary tabular-nums" data-id="element-43">
              {formatCurrency(data.totalBudget)}
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-44">
            <span className="text-xs font-body font-thin text-gray-500" data-id="element-45">
              Construction Escrow
            </span>
            <span className="text-sm font-body font-normal text-primary tabular-nums" data-id="element-46">
              {formatCurrency(data.constructionEscrow)}
            </span>
          </div>
          <div className="border-t border-gray-100 pt-2 flex justify-between items-center" data-id="element-47">
            <span className="text-xs font-body font-medium text-gray-600" data-id="element-48">
              Budget-Escrow Shortfall
            </span>
            <span className={`text-sm font-body font-medium tabular-nums ${shortfall > 0 ? 'text-red-600' : 'text-tertiary'}`} data-id="element-49">
              {formatCurrency(shortfall)}
            </span>
          </div>
        </div>

        {/* Right: Draw Info */}
        <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm space-y-3" data-id="element-50">
          <div className="flex justify-between items-center" data-id="element-51">
            <span className="text-xs font-body font-thin text-gray-500" data-id="element-52">
              Draw 1
            </span>
            <span className="text-sm font-body font-normal text-gray-400 tabular-nums" data-id="element-53">
              $ -
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-54">
            <span className="text-xs font-body font-thin text-gray-500" data-id="element-55">
              Budget-Escrow Shortfall
            </span>
            <span className="text-sm font-body font-normal text-primary tabular-nums" data-id="element-56">
              {formatCurrency(data.totalBudget)}
            </span>
          </div>
          <div className="border-t border-gray-100 pt-2 flex justify-between items-center" data-id="element-57">
            <span className="text-xs font-body font-medium text-gray-600" data-id="element-58">
              Net First Draw
            </span>
            <span className="text-sm font-body font-medium text-red-600 tabular-nums" data-id="element-59">
              ({formatCurrency(data.totalBudget)})
            </span>
          </div>
        </div>
      </div>
    </div>;
}